module.exports = __webpack_public_path__ + "static/ford-4c3973fca34285238a85a60b0f6ee8bf.png";